import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function EssentielTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    if (location.pathname === "/tarif_des_notaires") {
      window.gtag("event", "Essentiel_route (tarifs_des_notaires)", {
        event_category: "Navigation",
        event_label: "Page Tarif des Notaires",
      });
    }
  }, [location.pathname]);

  return null;
}